<template>
  <div ref="appContent" class="app-body">
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="100px"
    >
      <el-row :gutter="16" >
        <el-col :span="6">
          <el-form-item label="客户：" prop="customerId" label-width="80px">
            <el-select v-model="dataForm.customerId" size="mini" style="width: 100%" :filterable="true"
                       @change="customerChanged">
              <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="税号：" prop="taxCode" label-width="80px">
            <el-input v-model="dataForm.taxCode" placeholder="请输入税号" size="mini">></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="银行：" prop="bank" label-width="80px">
            <el-input v-model="dataForm.bank" placeholder="请输入银行" size="mini">></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="银行账号：" prop="accountCode">
            <el-input v-model="dataForm.accountCode" placeholder="请输入银行账号" size="mini">></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="table-bar" style="justify-content: flex-start">
        <div>
          <el-button
              size="mini"
              icon="el-icon-plus"
              @click="$refs.makeDetailDialog.init()"
              type="primary"
          >选择品番
          </el-button
          >
          <el-button
              size="mini"
              icon="el-icon-upload"
              @click="showCommonDialog()"
              type="warning"
          >导入明细
          </el-button>
        </div>
      </div>
      <SweetTable :data="dataForm.detailList" :height="tableHeight">
        <el-table-column label="外销合同号" prop="agreementCode" align="center" min-width="160">
        </el-table-column>
        <el-table-column label="出货工厂" align="center" min-width="200" prop="factoryName">
        </el-table-column>
        <el-table-column
            label="品番号"
            prop="code"
            align="center"
            min-width="160"
        >
        </el-table-column>
        <el-table-column
            label="SKU"
            prop="skuCode"
            align="center"
            min-width="160"
        >
        </el-table-column>
        <el-table-column label="品名" align="center" min-width="160" prop="name">
        </el-table-column>
        <el-table-column label="颜色" align="center" min-width="140" prop="color">
        </el-table-column>
        <el-table-column label="规格" align="center" min-width="140" prop="size">
        </el-table-column>
        <el-table-column label="出货数量" align="center" width="120">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.totalCount'"
                :rules="detailRule.totalCount"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.totalCount"
                  placeholder="出货数量"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="出货单价" align="center" width="120" v-if="type==='sell'">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.price'"
                :rules="detailRule.price"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.price"
                  placeholder="出货单价"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="每箱入数" align="center" width="120" v-if="type==='outlet'">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.preBoxCount'"
                :rules="detailRule.preBoxCount"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.preBoxCount"
                  placeholder="每箱入数"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="箱数"
            header-align="center"
            align="center"
            width="120"
            v-if="type==='outlet'"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.boxCount'"
                :rules="detailRule.boxCount"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input size="mini" v-model="scope.row.boxCount"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="纸箱尺寸" header-align="center" v-if="type==='outlet'">
          <el-table-column
              label="长(cm)"
              header-align="center"
              align="center"
              width="120"

          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.boxLong'"
                  :rules="detailRule.boxLong"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input size="mini" v-model="scope.row.boxLong"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="宽(cm)"
              header-align="center"
              align="center"
              width="120"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.boxWidth'"
                  :rules="detailRule.boxWidth"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input size="mini" v-model="scope.row.boxWidth"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="高(cm)"
              header-align="center"
              align="center"
              width="120"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.boxHeight'"
                  :rules="detailRule.boxHeight"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input
                    size="mini"
                    v-model="scope.row.boxHeight"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
            label="毛重(kg)"
            header-align="center"
            align="center"
            width="100"
            v-if="type==='outlet'"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.weight'"
                :rules="detailRule.weight"
                label-width="0"
                style="margin-top: 20px"
            >
              <el-input size="mini" v-model="scope.row.weight"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            width="100"
            label="操作"
            fixed="right"

        >
          <template slot-scope="scope">
            <el-button
                icon="el-icon-remove"
                type="text"
                @click="delRow(scope.$index, scope.row, 'detailList')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <div class="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </div>
    <common-upload
        ref="commonUpload"
        @success="uploadSuccessHandler"
        uploadUrl="/trade/boxform/import"
        templateUrl="/static/template/箱单导入模板.xlsx"
        title="箱单明细导入"
    ></common-upload>
    <make-detail-dialog ref="makeDetailDialog" :customer-id="dataForm.customerId" title="选择发货明细"
                        @change="makeDetailChange"></make-detail-dialog>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import MakeDetailDialog from '@/components/MakeDetailDialog'
import CommonDrop from '@/components/CommonDrop'
import { moneyValidator } from '@/utils/validate'

export default {
  name:'PaySellSave',
  components: { MakeDetailDialog, CommonDrop },
  data () {
    return {
      id: '',
      dataForm: {},
      tableHeight: 500,
      type: 'outlet',
      customerList: [],
      saving:false
    }
  },
  computed: {
    detailRule () {
      const numValidate = function (rule, value, callback) {
        if (!value) {
          callback()
        }
        let reg = /\d+/g
        if (!reg.test(value)) {
          callback(new Error('请输入正确的数字'))
        }
        callback()
      }
      return {
        totalCount: [
          { required: true, message: '请填写数量', trigger: 'change' },
          { validator: numValidate, trigger: 'change' },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
      }
    },
    dataRule () {
      return {
        customerId: [
          { required: true, message: '请选择客户', trigger: 'change' }],
        taxCode: [
          { required: true, message: '请填写税号', trigger: 'change' }],
        receiptCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
      }
    },
  },
  activated () {
    this.type = this.$route.query.type || 'outlet'
    this.id = this.$route.query.id
    if (this.type === 'sell') {
      this.queryCustomerList()
    }
    this.init()
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.appContent.clientHeight - 200
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs.makeDetailDialog) {
      this.$refs.makeDetailDialog.clearSelection()
    }
    next()
  },
  methods: {
    //客户下拉列表选择事件
    customerChanged (e) {
      let customer = this.customerList.find(item => item.id === e)
      if (!customer) {
        return
      }
      console.log(customer)
      this.dataForm.taxCode = customer.receiptCode
      this.dataForm.bank = customer.bankName
      this.dataForm.accountCode = customer.bankCode
    },
    //当销售开票时,查询客户列表
    async queryCustomerList () {
      const { data: res } = await this.$http.get(`/trade/customer/list`)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.customerList = res.data
    },
    //查询价格
    async queryPrice () {
      if (this.dataForm.detailList.length === 0) {
        return
      }
      let agreementIds = this.dataForm.detailList.map(item => item.agreementId)
      let productIds = this.dataForm.detailList.map(item => item.productId)
      let loading = this.$loading({
        lock: true,
        text: '正在读取价格'
      })
      try {
        const { data: res } = await this.$http.post(`/trade/agreement/detail/price`, { agreementIds, productIds })
        if (res.code != 0) {
          loading.close()
          return this.$message.error(res.msg)
        }
        if (!res.data || res.data.length === 0) {
          loading.close()
          return
        }
        res.data.forEach(item => {
          let row = this.dataForm.detailList.find(m => m.agreementId == item.agreementId && m.productId == item.productId)
          if (!row) {
            return
          }
          row.price = item.amount
        })

      } catch (e) {
        console.log(e)
      }
      loading.close()
    },
    codeDropLoaded (data) {
      if (this.id) {
        return false
      }
      this.codeDropToolTip = data.length === 0
    },
    makeDetailChange (e) {
      if (!e || e.length === 0) {
        return
      }
      let tmp = this.dataForm.detailList || []
      e.forEach(item => {
        if (tmp.find(m => m.id === item.id)) {
          return
        }
        tmp.push({
          id: item.id,
          agreementId: item.orderId,
          agreementCode: item.orderCode,
          productId: item.productId,
          code: item.code,
          name: item.name,
          size: item.size,
          color: item.color,
          skuCode: item.skuCode,
          factoryName: item.factoryName,
          factoryId: item.factoryId,
          boxCount: '',
          preBoxCount: '',
          totalCount: '',
          totalSize: '',
          weight: '',
          preSize: '',
          boxLong: '',
          boxWidth: '',
          boxHeight: '',
          price: 0
        })
      })
      this.$set(this.dataForm, 'detailList', tmp)
      //销售开票时查询价格
      if (this.type == 'sell') {
        this.queryPrice()
      }
    },
    //显示通用导入弹窗
    showCommonDialog () {
      this.$refs.commonUpload.init()
    },
    uploadSuccessHandler (e) {
      if (e && e.length > 0) {
        e = e.map(row => {
          return {
            ...row,
            factoryName: row.storageName
          }
        })
      }
      this.$set(this.dataForm, 'detailList', e)
    },

    delRow (index) {
      this.dataForm.detailList.splice(index, 1)
    },
    reset () {
      this.dataForm = {
        receiptCode: '',
        shipDate: '',
        destination: '',
        vesselName: '',
        fromHarbour: '',
        companyName: '',
        taxCode: '',
        bank: '',
        accountCode: '',
        detailList: [],
      }
    },
    async init () {
      this.reset()
      if (this.id) {
        this.getInfo()
      }
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
          .get(`/trade/boxform/${this.id}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.dataForm = {
              ...this.dataForm,
              ...res.data,
            }
          })
          .catch(() => {
          })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              ...this.dataForm,
              formType: this.type
            }
            postForm.detailList.forEach(item => {
              item.id = null
            })
            if(this.saving){
              return
            }
            this.saving=true
            this.$http.post('/trade/boxform/', postForm)
                .then(({ data: res }) => {
                  this.saving=false
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.cancel()
                    },
                  })
                })
                .catch(() => {
                  this.saving=false
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
    cancel () {
      this.$router.back()
    },
  },
}
</script>
